module.exports = __webpack_public_path__ + "img/花草_06.4ba8527d.png";